
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import tabsContent from "../tabs-content/tabs-content.vue";
@Component({
  components: {
    "pi-tabs-content": tabsContent
  }
})
export default class PiSysContent extends Vue {
  @Prop({ default: "" }) private title!: string;
  @Prop({ default: true }) private pageTitleShow!: boolean;
  @Prop({ default: true }) private white!: boolean;

  @Prop({ default: true }) private flexContent!: boolean;
  @Prop({ default: false }) private goBack!: boolean;
  @Prop({
    default: () => {
      return [];
    }
  })
  private tabsList!: object[];
  @Prop({ default: "" }) private tabsActive!: string;

  private win: objAny = window;
  public closeClick() {
    this.win.history.go(-1);
  }

  public tabChange(val: string | number): void {
    this.$emit("tabChange", val);
  }

  public goBackClick() {
    this.$common.goBack();
  }
}
